define.alias("shared/components/shared/ui/video", "preview-grid/components/shared/ui/video");